export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#80A868',
    contrastText: '#FFFFFF',
    light: '#80A8681a',
  },
  secondary: {
    main: '#FFFFFF',
    contrastText: '#668E4D',
  },
  text: {
    primary: '#404850',
    primaryLight: '#80A868',
    secondary: '#697883',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    main: '#FFF4E8',
    paper: '#FFF',
    default: '#FFF',
    footer: '#002855',
    level2: '#f7f8fb',
    level1: '#FFF',
    tableHead: '#DDDDDD',
    tableSubhead: '#FFF7F0',
    tableAlternate: '#F8F8F8',
    alternate: '#E3F1FD',
    success: '#DBEFDC',
    error: '#FFEAEA',
    secondary: '#F8D859',
    primary: '#80A868'
  },
  verticalBar: {
    used: '#7BD6D0',
    unused: '#7BD6D01a',
    unlimited: '#C0C0C0',
  }
};
